import { render } from "./PindaiView.vue?vue&type=template&id=0a685ec0"
import script from "./PindaiView.vue?vue&type=script&lang=js"
export * from "./PindaiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__